/* Stylesheet order is the contract: tokens define the variables everything else reads, glass uses
   them, layouts extend glass, and the shell owns only what a product may own — its layout. */
import '../../../packages/ankr-glass/src/tokens.css';
import '../../../packages/ankr-glass/src/glass.css';
import '../../../packages/ankr-glass/src/layouts.css';
import '../../../packages/ankr-glass/src/pause.css';
import './shell.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

/* The ephemeris travels WITH the app, because a candidate at sea has no server to ask. It is
   computation, not data — so there is nothing to download and no year in which it expires. */
import './offline/almanac.mjs';
import { registerOfflineWorker } from './offline/register-sw.mjs';
/* The marking engine travels too — deterministic arithmetic, no model, so it works whether or not
   an SLM is installed (founder's layering, 2026-08-12). */
import './offline/marking.mjs';
/* The browser's install offer fires seconds after load and only once. It is caught HERE, before the
   first render, because a listener added when the install panel opens has already missed it — and
   would then report "your browser does not offer installation" about a browser that did. */
import './offline/install-prompt.mjs';

createRoot(document.getElementById('root')).render(<StrictMode><App /></StrictMode>);

/* After the first render, never before it: registering a worker must not delay the app appearing. */
registerOfflineWorker();
